import React from "react";
import { Card } from "@chakra-ui/react";
import LessonIcon from "./LessonIcon";
import { haptic } from "@/lib/haptic";

interface LessonBlockProps {
  lessonNumber: number;
  description: string;
  status: "completed" | "current" | "locked";
  onClick: () => void;
  className?: string;
  buttonHeight?: string;
  fontSize?: string;
  hideDescription?: boolean;
}

const LessonBlock: React.FC<LessonBlockProps> = ({
  lessonNumber,
  description,
  status,
  fontSize = "",
  onClick,
  className,
  buttonHeight = "auto",
  hideDescription = false,
}) => {
  let smallerFont = "";
  if (fontSize != "") {
    const parsedFontSize = parseInt(fontSize);
    smallerFont = (parsedFontSize - 4).toString() + "px";
  }
  if (hideDescription) {
    smallerFont = fontSize;
  }
  const handleClick = () => {
    haptic.light();
    onClick();
  };
  return (
    <button
      onClick={handleClick}
      className={`w-full ${buttonHeight} ${className}`}
    >
      <Card
        variant="shadow"
        align="start"
        alignItems="center"
        direction="row"
        overflow="hidden"
        paddingY={"5px"}
        paddingX={"10px"}
        background={"#fafafa"}
        height={buttonHeight}
        rounded={"xl"}
      >
        <LessonIcon status={status} />
        <div className="ml-4 text-start gap-0 flex flex-col justify-center items-left">
          <div
            className={`${hideDescription ? "font-semibold" : "text-[10px]"}`}
            style={{ ...(smallerFont != "" && { fontSize: smallerFont }) }}
          >
            Lesson {lessonNumber}
          </div>
          {!hideDescription && (
            <div
              className={`font-semibold line-clamp-1`}
              style={{ ...(fontSize != "" && { fontSize: fontSize }) }}
            >
              {description}
            </div>
          )}
        </div>
      </Card>
    </button>
  );
};

export default LessonBlock;
